import request from "../utils/request";

export const list = (data) => request.get("/api/ticket", data);
export const archive = (id) => request.put(`/api/ticket/${id}`);
